export const hasLoadedFabricImage = (image) => {
  const element = image?._originalElement;
  return Boolean(element && element.naturalWidth > 0 && element.naturalHeight > 0);
};
